module.exports = __webpack_public_path__ + "static/glassHeartMobile-378c8bdd0a6b379b3ac4069c07e1fe76.png";